rdefine('app/formular/models/TabModel',['backbone'],function(Backbone) {
    return Backbone.Ribs.Model.extend({
        defaults:{
            module:function(){},
            options:{},
            title:'No title'
        }
    });
});